"use strict";

require("babel-polyfill");

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _objectFitImages = _interopRequireDefault(require("object-fit-images"));

var _smoothscrollPolyfill = _interopRequireDefault(require("smoothscroll-polyfill"));

var _reactRouterDom = require("react-router-dom");

var _release = _interopRequireDefault(require("./components/brunch-release/release.js"));

var _release2 = _interopRequireDefault(require("./components/schub-release/release.js"));

var _mainMenu = _interopRequireDefault(require("./components/main-menu"));

var _index = _interopRequireDefault(require("./components/lockpfosten-release/index"));

var _release3 = _interopRequireDefault(require("./components/stallvisite-release/release.js"));

var _release4 = _interopRequireDefault(require("./components/vomhof-release/release.js"));

var _release5 = _interopRequireDefault(require("./components/toh-release/release.js"));

var _release6 = _interopRequireDefault(require("./components/lgw-release/release.js"));

var _settings = _interopRequireDefault(require("./components/settings"));

var _projectList = _interopRequireDefault(require("./components/project-list"));

var _programList = _interopRequireDefault(require("./components/program-list"));

var _userList = _interopRequireDefault(require("./components/user-list"));

var _farmList = _interopRequireDefault(require("./components/farm-list"));

var _userView = _interopRequireDefault(require("./components/user-view"));

var _login = _interopRequireDefault(require("./components/login"));

var _subnavContentWrapper = _interopRequireDefault(require("./components/subnav-content-wrapper"));

var _topBtn = _interopRequireDefault(require("./components/top-btn"));

var _farmView = _interopRequireDefault(require("./components/farm-view"));

var _resolveDuplicates = _interopRequireDefault(require("./components/resolve-duplicates"));

var _dashboard = _interopRequireDefault(require("./components/dashboard"));

var _notFound = _interopRequireDefault(require("./components/not-found"));

var _exportContainer = _interopRequireDefault(require("./components/export-container"));

var _projectResetContainer = _interopRequireDefault(require("./components/project-reset-container"));

var _authorisation = _interopRequireDefault(require("./components/authorisation"));

var _createBrowserHistory = _interopRequireDefault(require("history/createBrowserHistory"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

var _picturefill = _interopRequireDefault(require("picturefill"));

require("picturefill/dist/plugins/mutation/pf.mutation.min");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var anyAuthorised = (0, _authorisation.default)(['admin', 'projectresponsible', 'cantonresponsible'], ['schub', 'vomhof', 'stallvisite', 'lockpfosten', 'brunch', 'toh', 'lgw'], true);
var admin = (0, _authorisation.default)(['admin'], [], true);
var schub = (0, _authorisation.default)(['admin', 'projectresponsible', 'cantonresponsible'], ['schub'], true);
var vomHof = (0, _authorisation.default)(['admin', 'projectresponsible', 'cantonresponsible'], ['vomhof'], true);
var stallvisite = (0, _authorisation.default)(['admin', 'projectresponsible', 'cantonresponsible'], ['stallvisite'], true);
var lockpfosten = (0, _authorisation.default)(['admin', 'projectresponsible', 'cantonresponsible'], ['lockpfosten'], true);
var brunch = (0, _authorisation.default)(['admin', 'projectresponsible', 'cantonresponsible'], ['brunch'], true);
var toh = (0, _authorisation.default)(['admin', 'projectresponsible', 'cantonresponsible'], ['toh'], true);
var lgw = (0, _authorisation.default)(['admin', 'projectresponsible', 'cantonresponsible'], ['lgw'], true);
var exportAuth = (0, _authorisation.default)(['admin', 'projectresponsible', 'cantonresponsible'], ['schub', 'vomhof', 'stallvisite', 'lockpfosten', 'brunch', 'toh', 'lgw'], true);
var resetProjectAuth = (0, _authorisation.default)(['admin', 'projectresponsible'], ['brunch', 'lockpfosten', 'toh'], true);
var customHistory = (0, _createBrowserHistory.default)();

//Polyfills for IE
_es6Promise.default.polyfill();

_smoothscrollPolyfill.default.polyfill();

(0, _picturefill.default)();
var DashboardSubNavContentWrapper = (0, _subnavContentWrapper.default)(_dashboard.default);

if (document.getElementById('app')) {
  if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
    localStorage.clear();
  }

  (0, _objectFitImages.default)();

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Router, {
    history: customHistory
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/",
    render: function render(props) {
      return /*#__PURE__*/_react.default.createElement(DashboardSubNavContentWrapper, _extends({}, props, {
        disableBackLink: true
      }));
    }
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/lockpfosten-release/:farmId",
    component: lockpfosten((0, _subnavContentWrapper.default)(_index.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/brunch-release/:farmId",
    component: brunch((0, _subnavContentWrapper.default)(_release.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/schub-release/:farmId",
    component: schub((0, _subnavContentWrapper.default)(_release2.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/stallvisite-release/:farmId",
    component: stallvisite((0, _subnavContentWrapper.default)(_release3.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/vomhof-release/:farmId",
    component: vomHof((0, _subnavContentWrapper.default)(_release4.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/toh-release/:farmId",
    component: toh((0, _subnavContentWrapper.default)(_release5.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/lgw-release/:farmId",
    component: lgw((0, _subnavContentWrapper.default)(_release6.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/projects",
    component: anyAuthorised((0, _subnavContentWrapper.default)(_projectList.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/programs",
    component: admin((0, _subnavContentWrapper.default)(_programList.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/users",
    component: anyAuthorised((0, _subnavContentWrapper.default)(_userList.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/user/:userId",
    component: anyAuthorised((0, _subnavContentWrapper.default)(_userView.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/farm/:farmId",
    component: anyAuthorised((0, _subnavContentWrapper.default)(_farmView.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/resolve-duplicates",
    component: admin((0, _subnavContentWrapper.default)(_resolveDuplicates.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/settings",
    component: admin((0, _subnavContentWrapper.default)(_settings.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/farms",
    component: anyAuthorised((0, _subnavContentWrapper.default)(_farmList.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/login",
    component: (0, _subnavContentWrapper.default)(_login.default)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/export-projects",
    component: exportAuth((0, _subnavContentWrapper.default)(_exportContainer.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: '/reset-projects',
    component: resetProjectAuth((0, _subnavContentWrapper.default)(_projectResetContainer.default))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    component: _notFound.default
  }))), document.getElementById('app'), function () {
    return (0, _topBtn.default)();
  });
}

_reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Router, {
  history: customHistory
}, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  exact: true,
  path: "/login",
  render: function render() {
    return '';
  }
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _mainMenu.default
}))), document.getElementById('menu'));


//////////////////
// WEBPACK FOOTER
// ./client/main.js
// module id = 268
// module chunks = 0